import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiUrlService } from '../../core/api-url.service';
import { SpwDesignSystemDirectivesModule } from '@spw-ds/spw-angular-library';

@Component({
  selector: 'app-admin-emails-page',
  standalone: true,
  imports: [FormsModule, NgIf, NgFor, SpwDesignSystemDirectivesModule],
  templateUrl: './admin-emails.page.html',
  styleUrl: './admin-emails.page.scss'
})
export class AdminEmailsPageComponent implements OnInit {
  templates: EmailTemplate[] = [];
  selectedType = '';
  templateContent = '';
  isLoading = false;
  isSaving = false;
  successMessage = '';
  errorMessage = '';

  readonly templateLabels: Record<string, string> = {
    NEXT_RESPONSIBLE: 'Responsable suivant',
    WARNING: 'Alerte plus de café'
  };


  constructor(
    private readonly http: HttpClient,
    private readonly apiUrl: ApiUrlService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.fetchTemplates();
  }

  fetchTemplates(): void {
    this.isLoading = true;
    this.errorMessage = '';
    this.http
      .get<EmailTemplate[]>(this.apiUrl.build('/api/admin/email-templates'))
      .subscribe({
        next: templates => {
          this.templates = templates;
          if (!this.selectedType && this.templates.length > 0) {
            this.selectedType = this.templates[0].type;
            this.templateContent = this.templates[0].content;
          } else {
            this.updateContentFromSelection();
          }
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.errorMessage = 'Impossible de charger les templates email.';
          this.isLoading = false;
          this.cdr.markForCheck();
        }
      });
  }

  onContentChanged(content: string | number): void {
    this.templateContent = String(content);
  }

  updateContentFromSelection(): void {
    const selected = this.templates.find(template => template.type === this.selectedType);
    this.templateContent = selected?.content ?? '';
  }

  saveTemplate(): void {
    if (!this.selectedType) {
      return;
    }
    this.isSaving = true;
    this.successMessage = '';
    this.errorMessage = '';
    this.http
      .put<EmailTemplate>(
        this.apiUrl.build(`/api/admin/email-templates/${this.selectedType}`),
        { content: this.templateContent }
      )
      .subscribe({
        next: updated => {
          this.templates = this.templates.map(template =>
            template.type === updated.type ? updated : template
          );
          this.templateContent = updated.content;
          this.successMessage = 'Template enregistré.';
          this.isSaving = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.errorMessage = 'Impossible de sauvegarder le template.';
          this.isSaving = false;
          this.cdr.markForCheck();
        }
      });
  }
}

interface EmailTemplate {
  type: string;
  content: string;
}
